const ResultPage = (result) => {


    return ( 
            <div className="container">
                <div className="row center-div preds">
                    {console.log('result page result',result)}
                    {console.log('result page result.result',result.result.category)}
                    <div className="col-12 center-div pred-cat"> Predicted Category: { result.result.category ?? 'not exist'} {JSON.stringify(result)}</div>)
                </div>
                
            </div>
        );

}

export default ResultPage;